import React from 'react';
import './PortManager.less';
import { FormattedMessage } from 'react-intl';
import { Button, Input, Select, Tabs } from 'antd';

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const TextArea = Input.TextArea;
const EXCHANGE_TAB = '1';
const INFRARED_TAB = '2';

//会议室服务管理
class PortManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeKey: EXCHANGE_TAB };
  }

  render() {
    const { activeKey } = this.state;
    const { intl } = this.props;
    return (
      <div className="port-container">
        <Tabs
          type="card"
          activeKey={activeKey}
          onChange={activeKey => this.setState({ activeKey: activeKey })}
        >
          <TabPane key={EXCHANGE_TAB} tab={'Exchange'}>
            {this.exchangeTab()}
          </TabPane>
          {/*<TabPane key={INFRARED_TAB} tab={'红外'}>{this.infraredTab()}</TabPane>*/}
        </Tabs>
      </div>
    );
  }

  /**
   * ExchangeTab
   * @returns {*}
   */
  exchangeTab = () => {
    const { intl, dispatch, exchangeData = {} } = this.props;
    let connected = Number(exchangeData.status) == 1;
    return (
      <div className="exchange-tab">
        {/*<span className='exchange-tab-title'>Exchange配置</span>*/}
        <div className="exchange-tab-body">
          <div className="exchange-row">
            <div className="exchange-prefix-title">
              <i className="iconfont icon-bitian" />
              <FormattedMessage id="port_manage_protocol" /> :{' '}
            </div>
            <div className="exchange-content">
              <Select
                className="exchange-select"
                value={exchangeData.protocol || ''}
                onSelect={v => {
                  exchangeData.protocol = v;
                  dispatch({ type: 'account/update', payload: exchangeData });
                }}
              >
                <Option key="https://">Https://</Option>
                <Option key="http://">Http://</Option>
              </Select>
            </div>
          </div>
          <div className="exchange-row">
            <div className="exchange-prefix-title">
              <i className="iconfont icon-bitian" />
              <FormattedMessage id="port_manage_version" /> :
            </div>
            <div className="exchange-content">
              <Select
                className="exchange-select"
                value={exchangeData.version || ''}
                onSelect={(v, o) => {
                  exchangeData.version = v;
                  exchangeData.name = o.props.name;
                  dispatch({ type: 'account/update', payload: exchangeData });
                }}
              >
                <Option key="2010" name={'Microsoft Exchange 2010'}>
                  Microsoft Exchange 2010
                </Option>
                <Option key="2013" name={'Microsoft Exchange 2013'}>
                  Microsoft Exchange 2013
                </Option>
                <Option key="2016" name={'Microsoft Exchange 2016'}>
                  Microsoft Exchange 2016
                </Option>
                <Option key="Online" name={'Microsoft Exchange Online'}>
                  Microsoft Exchange Online
                </Option>
              </Select>
            </div>
          </div>
          <div className="exchange-row">
            <div className="exchange-prefix-title">
              <i className="iconfont icon-bitian" />
              <FormattedMessage id="port_manage_ip" /> :
            </div>
            <div className="exchange-content">
              <Input
                className="exchange-input"
                maxLength={'50'}
                value={exchangeData.ip || ''}
                onChange={e => {
                  exchangeData.ip = e.target.value;
                  dispatch({ type: 'account/update', payload: exchangeData });
                }}
              />
            </div>
          </div>
          <div className="exchange-row">
            <div className="exchange-prefix-title">
              <i className="iconfont icon-bitian" />
              <FormattedMessage id="port_manage_account" /> :
            </div>
            <div className="exchange-content">
              <Input
                className="exchange-input"
                maxLength={'50'}
                value={exchangeData.account || ''}
                onChange={e => {
                  exchangeData.account = e.target.value;
                  dispatch({ type: 'account/update', payload: exchangeData });
                }}
              />
            </div>
          </div>
          <div className="exchange-row">
            <div className="exchange-prefix-title">
              <i className="iconfont icon-bitian" />
              <FormattedMessage id="port_manage_password" /> :
            </div>
            <div className="exchange-content">
              <Input
                className="exchange-input"
                type={'password'}
                maxLength={'50'}
                value={exchangeData.password || ''}
                onChange={e => {
                  exchangeData.password = e.target.value;
                  dispatch({ type: 'account/update', payload: exchangeData });
                }}
              />
            </div>
          </div>
          <div className="exchange-row-area">
            <div className="exchange-prefix-title">
              <FormattedMessage id="port_manage_describe" /> :
            </div>
            <div className="exchange-content">
              <TextArea
                className="exchange-input"
                autosize={{ minRows: 3, maxRows: 3 }}
                maxLength={'200'}
                value={exchangeData.remark || ''}
                onChange={e => {
                  exchangeData.remark = e.target.value;
                  dispatch({ type: 'account/update', payload: exchangeData });
                }}
              />
            </div>
          </div>
          <div className="exchange-row">
            <div className="exchange-prefix-title" />
            <div className="exchange-content">
              <Button
                type="primary"
                style={{ marginRight: '24px' }}
                onClick={() =>
                  dispatch({ type: 'account/setExchange', operateType: 0 })
                }
              >
                <FormattedMessage id="port_manage_btn_save" />
              </Button>
              {connected ? (
                <div>
                  <Button
                    onClick={() =>
                      dispatch({ type: 'account/setExchange', operateType: 1 })
                    }
                  >
                    <FormattedMessage id="port_manage_btn_disconnect" />
                  </Button>
                  {/*<Icon type="check-circle" style={{fontSize: 16, color: '#89CB5F', margin: '0 5px 0 24px'}}/>
                  <span>{'已连接'}</span>*/}
                </div>
              ) : (
                <div>
                  <Button
                    onClick={() => dispatch({ type: 'account/testExchange' })}
                  >
                    <FormattedMessage id="port_manage_btn_connect" />
                  </Button>
                  {/*<Icon type="close-circle" style={{fontSize: 16, color: '#E86461', margin: '0 5px 0 24px'}}/>
                  <span>{'已断开'}</span>*/}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  /**
   * 红外Tab
   * @returns {*}
   */
  infraredTab = () => {
    const { intl, dispatch, infraredData } = this.props;
    return (
      <div className="infrared-tab">
        {/*<span className='infrared-tab-title'>红外感应</span>*/}
        <div className="infrared-tab-body">
          <div className="infrared-row">
            <span className="infrared-prefix-title">红外线设备</span>
            <div className="infrared-content">
              <Input
                className="infrared-input"
                maxLength={'5'}
                value={infraredData || ''}
                onChange={e => {
                  let value = e.target.value;
                  let reg = /^[0-9]*$/;
                  if (value !== '' && !reg.test(value)) return;
                  dispatch({
                    type: 'account/update',
                    payload: { infraredData: value }
                  });
                }}
              />
              <span>分钟感应不到人，自动关闭会议</span>
            </div>
          </div>
          <div className="infrared-row">
            <span className="infrared-prefix-title" />
            <div className="infrared-content">
              <Button type="primary" onClick={() => {}}>
                保存
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default PortManager;



// WEBPACK FOOTER //
// ./src/components/account/PortManager.js